import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { RootState } from "../../models/RootState";
import { fetchEventsBySport } from "../../store";
import { useParams } from "react-router-dom";
import EventsTable from "../../components/EventsTable/EventsTable";
import { SportRadarEventsTable } from "../../components/EventsTable/SportRadarEventTable";
import { SportRadarEventCard } from "../../components/EventsCards/SportRadarEventCard";
import { EventData } from "../../models/EventData";
import EventCard from "../../components/EventsCards/EventCard";
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";
import "./SportView.scss";
import { unsubscribeAllWsforEvents } from "../../websockets/websocket";
import { SettingsOutlined } from "@mui/icons-material";
import RightSideNav from "../../components/RightSideNav/RightSideNav";

type StoreProps = {
  fetchEventsBySport: Function;
  events: EventData[];
  grid: boolean;
  providerId: string;
};

const SportView: React.FC<StoreProps> = (props) => {
  const { fetchEventsBySport, events, grid, providerId } =
    props;
  const [wsChannels, setWsChannels] = useState<string[]>([]);

  let urlParams = useParams();

  useEffect(() => {
    fetchEventsBySport(urlParams.sportId);
  }, [providerId, urlParams]);

  useEffect(() => {
    let refreshInterval = setInterval(() => {
      if (urlParams.sportId) fetchEventsBySport(urlParams.sportId);
    }, 10000);
    return () => {
      clearInterval(refreshInterval);
    };
  }, [providerId, urlParams]);

  useEffect(() => {
    unsubscribeAllWsforEvents();
    setWsChannels([]);
  }, [urlParams.sportId]);

  // useEffect(() => {
  //   unsubscribeAllWsforEvents();
  //   setWsChannels([]);
  //   console.log(urlParams.sportId);

  //   if (
  //     events &&
  //     events.length > 0 &&
  //     events[0].sportId === urlParams.sportId
  //   ) {
  //     console.log(events[0].sportId);
  //     let subs = [...wsChannels];
  //     for (let event of events) {
  //       if (
  //         event.status === "IN_PLAY" &&
  //         event.markets.matchOdds &&
  //         event.markets.matchOdds.length > 0 &&
  //         !wsChannels.includes(event.eventId)
  //       ) {
  //         subs.push(event.eventId);
  //         subscribeDreamWsForMatchOdds(
  //           sessionStorage.getItem("psProviderId"),
  //           event.eventId,
  //           event.marketId,
  //           true
  //         );
  //       }
  //     }
  //   }

  //   // console.log(urlParams.sportId);

  //   return () => {
  //     unsubscribeAllWsforEvents();
  //   };
  // }, [providerId, urlParams.sportId]);

  return (
    <div className="sport-ctn">
      {providerId === "SportRadar" ? (
        <>
          {grid ? (
            <SportRadarEventCard events={events} />
          ) : (
            <SportRadarTable events={events} />
          )}
        </>
      ) : (
        <>
          {!grid ? (
            <>
              <div className="left-ctn">
                <EventsTable events={events} />
              </div>
              {/* <div className="right-ctn web-view">
                <RightSideNav
                  hideOpenBets={true}
                  hideRightCtn={providerId === "SportRadar" ? true : false}
                />
              </div> */}
            </>
          ) : (
            <EventCard events={events} />
          )}
        </>
      )}
    </div>
  );
};

const SportRadarTable = (props) => {
  const { events } = props;
  const [value, setValue] = React.useState("future");
  const [eventData, setEventData] = React.useState([]);

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    console.log(newValue);
    setValue(newValue);
  };

  // useEffect(() => {
  //   if (value === "inPlay") {
  //     let data =
  //       events && events.length
  //         ? events.filter((itm) => itm.status === "IN_PLAY")
  //         : [];
  //     setEventData(data);
  //   } else {
  //     let data =
  //       events && events.length
  //         ? events.filter((itm) => itm.status !== "IN_PLAY")
  //         : [];
  //     setEventData(data);
  //   }
  // }, [value, events]);

  return (
    <TableContainer>
      <Table
        className="sportrader-events-tbl-ctn"
        aria-label="a dense table"
        size="small"
      >
        <TableHead className="web-view">
          <TableRow className="title-row">
            <TableCell className="score-detail">Date</TableCell>
            <TableCell colSpan={2}>
              Events
              {/* {events && events.length ? (
                <div className="sport-name">
                  {events[0]?.sportName === "Cricket" ? (
                    <img src={cricket} alt="cricket" />
                  ) : events[0]?.sportName === "Soccer" ? (
                    <img src={soccer} alt="soccer" />
                  ) : events[0]?.sportName === "Tennis" ? (
                    <img src={tennis} alt="tennis" />
                  ) : null}{" "}
                  {events[0]?.sportName + "/events"}{" "}
                </div>
              ) : null} */}
            </TableCell>

            <TableCell></TableCell>
            <TableCell align="center">
              <div className="market">
                <div>1</div>
                <div>X</div>
                <div>2</div>
              </div>
            </TableCell>

            <TableCell align="center">HCP</TableCell>
            <TableCell align="center">TOT</TableCell>
            <TableCell align="center"></TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {events && events.length ? (
            events.map((itm, index) => {
              return (
                <>
                  {!["closed"].includes(itm.status.toLowerCase()) ? (
                    <SportRadarEventsTable
                      // eventStatus={
                      //   eventEnableStatus.includes(itm.status.toLowerCase())
                      //     ? true
                      //     : false
                      // }
                      eventData={itm}
                      key={index}
                    />
                  ) : null}
                </>
              );
            })
          ) : (
            <TableRow>
              <TableCell colSpan={9}>
                {value === "inPlay" ? "No Inplay Events" : " No Events"}
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    events: state.sportsBook.events,
    operatorId: state.auth.operatorId,
    loggedIn: state.auth.loggedIn,
    grid: state.auth.grid,
    providerId: state.auth.providerId,
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    fetchEventsBySport: (sportId: string) =>
      dispatch(fetchEventsBySport(sportId))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SportView);
